import React, { useEffect, useState } from "react";
import { supabase } from "../../supabase-client";
import PedidoModal from "../../components/modal/PedidoModal"; // 👈 Import the modal
import {
   Eye,
   CheckCircle,
   XCircle,
   Clock,
   Package,
   Truck,
   DollarSign,
} from "lucide-react";
// import { i } from "framer-motion/client";

export default function Mispedidos() {
   const [pedidos, setPedidos] = useState([]);
   const [loading, setLoading] = useState(true);
   const [selectedPedido, setSelectedPedido] = useState(null);
   const [filterEstado, setFilterEstado] = useState("todos");

   // Estados disponibles
   const estados = {
      pendiente: {
         label: "Pendiente",
         color: "bg-yellow-100 text-yellow-800",
         icon: Clock,
      },
      confirmado: {
         label: "Confirmado",
         color: "bg-blue-100 text-blue-800",
         icon: CheckCircle,
      },
      pagado: {
         label: "Pagado",
         color: "bg-blue-100 text-blue-800",
         icon: DollarSign,
      },
      procesando: {
         label: "Procesando",
         color: "bg-purple-100 text-purple-800",
         icon: Package,
      },
      enviado: {
         label: "Enviado",
         color: "bg-green-100 text-green-800",
         icon: Truck,
      },
      entregado: {
         label: "Entregado",
         color: "bg-green-100 text-green-800",
         icon: CheckCircle,
      },
      cancelado: {
         label: "Cancelado",
         color: "bg-red-100 text-red-800",
         icon: XCircle,
      },
   };
   console.log("estados: ", estados);

   // Fetch pedidos from database
   const fetchPedidos = async () => {
      setLoading(true);
      try {
         const { data: users, error: fetchError } = await supabase
            .from("usuarios") // Assuming you have an admin_users table
            .select("*")
            .eq("password_hash", localStorage.getItem("authjwt"))
            .single();

         if (fetchError) {
            console.error("Error fetching user:", fetchError);
            return;
         }

         if (!users) {
            console.error("No user found");
            return;
         }

         const { data, error } = await supabase
            .from("pedidos")
            .select(
               `
               *,
               usuarios (
                  id,
                  nombre,
                  email,
                  documento,
                  celular
               )
            `
            )
            .eq("usuario_id", users.id)
            .order("fecha_pedido", { ascending: false });

         if (error) {
            console.error("Error fetching pedidos:", error);
            alert("Error al cargar los pedidos");
            return;
         }

         setPedidos(data || []);
         console.log("data: ", data);
      } catch (err) {
         console.error("Error:", err);
         alert("Error al conectar con la base de datos");
      }
      setLoading(false);
   };

   // Filter pedidos by estado
   const filteredPedidos =
      filterEstado === "todos"
         ? pedidos
         : pedidos.filter((pedido) => pedido.estado === filterEstado);

   // Format date
   const formatDate = (dateString) => {
      return new Date(dateString).toLocaleString("es-AR", {
         year: "numeric",
         month: "2-digit",
         day: "2-digit",
         hour: "2-digit",
         minute: "2-digit",
      });
   };

   // Parse obras JSON safely
   // const parseObras = (obrasJson) => {
   //    try {
   //       return JSON.parse(obrasJson || "[]");
   //    } catch {
   //       return [];
   //    }
   // };

   useEffect(() => {
      fetchPedidos();
   }, []);

   if (loading) {
      return (
         <div className="p-6 text-center">
            <h1 className="text-3xl font-bold mb-4">Pedidos</h1>
            <div className="flex items-center justify-center">
               <div className="animate-spin rounded-full h-8 w-8 border-2 border-blue-500 border-t-transparent"></div>
               <span className="ml-2">Cargando pedidos...</span>
            </div>
         </div>
      );
   }

   console.log("pedidos: ", pedidos);
   return (
      <div className="p-4 md:p-6 max-w-7xl mx-auto">
         <div className="flex justify-between items-center mb-6">
            <h1 className="text-2xl md:text-3xl font-bold">Mis Pedidos</h1>
            <button
               onClick={fetchPedidos}
               className="bg-blue-500 hover:bg-blue-600 text-white px-3 md:px-4 py-2 rounded-lg transition-colors text-sm md:text-base"
            >
               🔄 <span className="hidden sm:inline">Actualizar</span>
            </button>
         </div>

         {/* Statistics - Hidden on mobile */}
         <div className="hidden md:grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 gap-4 mb-6">
            <div className="bg-gray-50 p-4 rounded-lg text-center">
               <div className="text-2xl font-bold text-gray-700">
                  {pedidos.length}
               </div>
               <div className="text-sm text-gray-600">Total</div>
            </div>
            {Object.entries(estados).map(([key, config]) => {
               const count = pedidos.filter((p) => p.estado === key).length;
               return (
                  <div
                     key={key}
                     className="bg-gray-50 p-4 rounded-lg text-center"
                  >
                     <div className="text-2xl font-bold text-gray-700">
                        {count}
                     </div>
                     <div className="text-sm text-gray-600">{config.label}</div>
                  </div>
               );
            })}
         </div>

         {/* Filters */}
         <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">
               Filtrar por estado:
            </label>
            <select
               value={filterEstado}
               onChange={(e) => setFilterEstado(e.target.value)}
               className="w-full md:w-auto border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
               <option value="todos">Todos los estados</option>
               {Object.entries(estados).map(([key, config]) => (
                  <option key={key} value={key}>
                     {config.label}
                  </option>
               ))}
            </select>
         </div>

         {/* Pedidos Table - Also make it responsive */}
         {filteredPedidos.length === 0 ? (
            <div className="text-center py-8 text-gray-500">
               {filterEstado === "todos"
                  ? "No hay pedidos registrados"
                  : `No hay pedidos con estado: ${estados[filterEstado]?.label}`}
            </div>
         ) : (
            <div className="bg-white rounded-lg shadow overflow-hidden">
               {/* Mobile Card View */}
               <div className="md:hidden">
                  {filteredPedidos.map((pedido) => {
                     const estadoConfig =
                        estados[pedido.estado] || estados.pendiente;
                     const IconComponent = estadoConfig.icon;

                     return (
                        <div
                           key={pedido.id}
                           className="p-4 border-b border-gray-200"
                        >
                           <div className="flex justify-between items-start mb-2">
                              <div className="font-medium text-gray-900">
                                 Pedido #{pedido.id}
                              </div>
                              <span
                                 className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${estadoConfig.color}`}
                              >
                                 <IconComponent className="w-3 h-3 mr-1" />
                                 {estadoConfig.label}
                              </span>
                           </div>

                           <div className="text-sm text-gray-600 mb-2">
                              {pedido.titulo}
                           </div>
                           <div className="text-sm text-gray-600 mb-2">
                              {formatDate(pedido.fecha_pedido)}
                           </div>

                           <div className="flex justify-between items-center">
                              <div className="text-lg font-bold text-green-600">
                                 ${Number(pedido.total || 0).toLocaleString()}
                              </div>
                              <button
                                 onClick={() => setSelectedPedido(pedido)}
                                 className="text-blue-600 hover:text-blue-900 transition-colors"
                                 title="Ver detalles"
                              >
                                 <Eye className="w-4 h-4" />
                              </button>
                           </div>
                        </div>
                     );
                  })}
               </div>

               {/* Desktop Table View */}
               <table className="hidden md:table w-full">
                  <thead className="bg-gray-50">
                     <tr>
                        <th className="px-4 py-3 text-left text-sm font-medium text-gray-500 uppercase tracking-wider">
                           ID
                        </th>
                        <th className="px-4 py-3 text-left text-sm font-medium text-gray-500 uppercase tracking-wider">
                           Fecha Pedido
                        </th>
                        <th className="px-4 py-3 text-left text-sm font-medium text-gray-500 uppercase tracking-wider">
                           Cliente
                        </th>
                        <th className="px-4 py-3 text-left text-sm font-medium text-gray-500 uppercase tracking-wider">
                           Total
                        </th>
                        <th className="px-4 py-3 text-left text-sm font-medium text-gray-500 uppercase tracking-wider">
                           Estado
                        </th>
                        <th className="px-4 py-3 text-left text-sm font-medium text-gray-500 uppercase tracking-wider">
                           Acciones
                        </th>
                     </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                     {filteredPedidos.map((pedido) => {
                        const estadoConfig =
                           estados[pedido.estado] || estados.pendiente;
                        const IconComponent = estadoConfig.icon;

                        return (
                           <tr key={pedido.id} className="hover:bg-gray-50">
                              <td className="px-4 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                                 #{pedido.id}
                              </td>
                              <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900">
                                 {formatDate(pedido.fecha_pedido)}
                              </td>
                              <td className="px-4 py-4 whitespace-nowrap">
                                 <div className="text-sm font-medium text-gray-900">
                                    {pedido.usuarios?.nombre || "N/A"}
                                 </div>
                                 <div className="text-sm text-gray-500">
                                    {pedido.usuarios?.email || "N/A"}
                                 </div>
                              </td>
                              <td className="px-4 py-4 whitespace-nowrap text-sm font-bold text-green-600">
                                 ${Number(pedido.total || 0).toLocaleString()}
                              </td>
                              <td className="px-4 py-4 whitespace-nowrap">
                                 <span
                                    className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${estadoConfig.color}`}
                                 >
                                    <IconComponent className="w-3 h-3 mr-1" />
                                    {estadoConfig.label}
                                 </span>
                              </td>
                              <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-500">
                                 <div className="flex space-x-2">
                                    <button
                                       onClick={() => setSelectedPedido(pedido)}
                                       className="text-blue-600 hover:text-blue-900 transition-colors"
                                       title="Ver detalles"
                                    >
                                       <Eye className="w-4 h-4" />
                                    </button>
                                 </div>
                              </td>
                           </tr>
                        );
                     })}
                  </tbody>
               </table>
            </div>
         )}

         {/* Modal remains the same */}
         <PedidoModal
            pedido={selectedPedido}
            onClose={() => setSelectedPedido(null)}
         />
      </div>
   );
}
